export default __webpack_public_path__ + "static/media/avatar.fb1231bb.png";